import { render } from "./PurchaseShowComponent.vue?vue&type=template&id=5b34a15c&scoped=true"
import script from "./PurchaseShowComponent.vue?vue&type=script&lang=js"
export * from "./PurchaseShowComponent.vue?vue&type=script&lang=js"

import "./PurchaseShowComponent.vue?vue&type=style&index=0&id=5b34a15c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b34a15c"],['__file',"resources/js/components/admin/purchase/PurchaseShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b34a15c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b34a15c', __exports__)) {
    api.reload('5b34a15c', __exports__)
  }
  
  module.hot.accept("./PurchaseShowComponent.vue?vue&type=template&id=5b34a15c&scoped=true", () => {
    api.rerender('5b34a15c', render)
  })

}


export default __exports__